import { create } from 'zustand';

/**
 * Whether a shopper is signed in, and the small amount of identity the shell
 * needs to render — a name in the header, a pincode for delivery estimates.
 *
 * The customer record itself is server state and lives in TanStack Query. What
 * is here is the flag that decides which header to draw and the last pincode
 * typed, which is a preference rather than a fetched fact.
 */

const readPincode = () => {
  try {
    return localStorage.getItem('ge:pincode') ?? '';
  } catch {
    return '';
  }
};

export const useSession = create((set) => ({
  /**
   * Starts unknown rather than false. Drawing the signed-out header and then
   * swapping it a moment later is a flash every returning customer sees.
   */
  status: 'unknown',
  name: '',

  signedIn: (customer) => set({ status: 'authenticated', name: customer?.name ?? '' }),
  signedOut: () => set({ status: 'guest', name: '' }),

  pincode: readPincode(),
  setPincode: (pincode) => {
    set({ pincode });
    try {
      if (pincode) localStorage.setItem('ge:pincode', pincode);
      else localStorage.removeItem('ge:pincode');
    } catch {
      // Storage being unavailable costs a convenience, not a purchase.
    }
  },
}));

export default useSession;
